<template>
  <div>
    <FieldSpan
      v-bind:style-to-add="approvalStatusListStyle(product.approvalStatus)"
      v-bind:value="product.approvalStatus"
    />
    <FieldSpan
      class="ml-3"
      v-bind:style-to-add="contractStatusListStyle(product.contractStatus)"
      v-bind:value="product.contractStatus"
    />
    <FieldSpan
      class="ml-3"
      v-bind:style-to-add="enabledStyle(product.enabled)"
      v-bind:value="product.enabled ? 'Enabled' : 'Disabled'"
    />
    <FieldSpan class="ml-3" v-bind:style-to-add="sourceStyle(product.source)" v-bind:value="product.source" />
    <XCircleIcon v-if="variantStatusNotValid(product)" class="inline-flex ml-2 h-5 w-5 text-red-700"></XCircleIcon>
  </div>
</template>

<script>
import { FieldSpan } from "@estaly/ui";
import { XCircleIcon } from "@heroicons/vue/outline";
import { mapGetters } from "vuex";

export default {
  components: {
    FieldSpan,
    XCircleIcon,
  },

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters("products", [
      "approvalStatusListStyle",
      "contractStatusListStyle",
      "enabledStyle",
      "sourceStyle",
      "variantStatusNotValid",
    ]),
  },
};
</script>
